import React from 'react';

import type { COLORS } from '~/components/core/StatusChipCore';
import StatusChipCore from '~/components/core/StatusChipCore';
import { CheckIcon, CloseIcon_Deprecated, FilesIcon } from '~/components/icons';
import type { IconProps } from '~/components/icons/types';
import { FnolInboxRecordFnolInboxStatus } from '~/server_shared/openapi/data-contracts';

export interface FnolInboxStatusChipProps {
  status: FnolInboxRecordFnolInboxStatus;
}

type StatusConfig = {
  [key in FnolInboxRecordFnolInboxStatus]: {
    color?: COLORS;
    icon?: React.FC<IconProps>;
    name: string;
  } | null;
};

const STATUS_CONFIG: StatusConfig = {
  [FnolInboxRecordFnolInboxStatus.AiProcessing]: null,
  [FnolInboxRecordFnolInboxStatus.Created]: { color: 'green', icon: CheckIcon, name: 'created' },
  [FnolInboxRecordFnolInboxStatus.AiProcessingFailed]: null,
  [FnolInboxRecordFnolInboxStatus.New]: null,
  [FnolInboxRecordFnolInboxStatus.NoLobAndSubOrg]: null,
  [FnolInboxRecordFnolInboxStatus.AiNew]: null,
  [FnolInboxRecordFnolInboxStatus.Attached]: { color: 'yellow', icon: FilesIcon, name: 'attached' },
  [FnolInboxRecordFnolInboxStatus.Dismissed]: { color: 'grey', icon: CloseIcon_Deprecated, name: 'dismissed' },
  [FnolInboxRecordFnolInboxStatus.AiPolicyNotFound]: null,
};

export const FnolInboxStatusChip: React.FC<FnolInboxStatusChipProps> = ({ status }) => {
  const statusInfo = STATUS_CONFIG[status];
  if (!statusInfo) {
    // Return null for statuses that don't have a chip configuration
    return null;
  }

  const { name, color, icon } = statusInfo;
  return <StatusChipCore status={name} color={color} Icon={icon} />;
};
